import { SearchConfig } from '../../../app/config/model/search-config.model';
import { LayerCode } from '../../../app/shared/enum/layer-code.enum';
import { SERVICE_TYPES } from '../../../app/shared/enum/services-type.enum';
import { Workspace } from '../../../app/shared/enum/workspace.enum';

const defaultMarker = {
  id: 'esrisearchPoint',
  type: 'simple-marker',
  style: 'circle',
  color: [255, 0, 0, 0.3],
  outline: {
    color: [170, 0, 0],
    width: '3px',
  },
  size: '40px',
};

const defaultProperties = {
  exactMatch: false,
  prefix: '%',
  suffix: '%',
  maxResults: 10,
  maxSuggestions: 10,
  suggestionsEnabled: true,
  minSuggestCharacters: 2,
  zoomScale: 5000,
  resultSymbol: defaultMarker,
};

export const SEARCH_CONFIG: SearchConfig = {
  allPlaceholders: [
    {
      placeholder: 'JSON_CONFIG.SEARCH.ALL_PLACEHOLDER',
    },
    {
      fkArbeitsbereich: Workspace.sbb_eigentumsflaeche,
      placeholder: 'JSON_CONFIG.SEARCH.ALL_PLACEHOLDER',
    },
  ],
  sources: [
    {
      type: 'locator',
      properties: {
        url: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer',
        countryCode: 'CHE',
        singleLineFieldName: 'SingleLine',
        outFields: ['Addr_type'],
        name: 'JSON_CONFIG.SEARCH.LOCATOR_NAME',
        localSearchOptions: {
          minScale: 300000,
          distance: 50000,
        },
        placeholder: 'JSON_CONFIG.SEARCH.LOCATOR_PLACEHOLDER',
        resultSymbol: defaultMarker,
      },
    },
    {
      type: SERVICE_TYPES.featureLayer,
      fkLayer: LayerCode.f_betriebspunkt,
      properties: {
        searchFields: ['ABKUERZUNG', 'BEZEICHNUNG'],
        outFields: ['ABKUERZUNG', 'BEZEICHNUNG'],
        orderByFields: ['ABKUERZUNG', 'BEZEICHNUNG'],
        suggestionTemplate: '{ABKUERZUNG} | {BEZEICHNUNG}',
        name: 'JSON_CONFIG.SEARCH.BETRIEBSPUNKT_NAME',
        placeholder: 'JSON_CONFIG.SEARCH.BETRIEBSPUNKT_PLACEHOLDER',
        ...defaultProperties,
      },
    },
    {
      comment: 'search parzelle_Locate_view',
      type: SERVICE_TYPES.custom_search_Layer,
      fkLayer: LayerCode.f_parzelle_Locate_view,
      properties: {
        featureCode: LayerCode.f_parzelle_Locate_view,
        searchFields: ['LOCATE'],
        suggestionTemplate:
          '{GEMEINDE} | (PARZNR): {PARZNR} | EGRID: {EGRID}',
        splitSuggestion: false,
        outFields: ['GEMEINDE', 'PARZNR', 'EGRID'],
        orderByFields: ['GEMEINDE', 'PARZNR', 'EGRID'],
        name: 'JSON_CONFIG.SEARCH.LOCATE_PARZELLEN',
        placeholder: 'JSON_CONFIG.SEARCH.LOCATE_PARZELLEN',
        ...defaultProperties,
      },
    },
    {
      comment: 'search teilparzelle_Locate_view',
      type: SERVICE_TYPES.custom_search_Layer,
      fkLayer: LayerCode.f_teilparzelle_Locate_view,
      properties: {
        featureCode: LayerCode.f_teilparzelle_Locate_view,
        searchFields: ['LOCATE'],
        suggestionTemplate:
          '{GEMEINDE} | (PARZNR): {PARZNR} | EGRID: {EGRID} | (ANLAGE_NR):{ANLAGE_NR}',
        splitSuggestion: false,
        outFields: ['GEMEINDE', 'PARZNR', 'EGRID', 'ANLAGE_NR'],
        orderByFields: ['GEMEINDE', 'PARZNR', 'EGRID', 'ANLAGE_NR'],
        name: 'JSON_CONFIG.SEARCH.LOCATE_TEILPARZELLEN',
        placeholder: 'JSON_CONFIG.SEARCH.LOCATE_TEILPARZELLEN',
        ...defaultProperties,
      },
    },
    {
      type: SERVICE_TYPES.custom_search_Layer,
      fkArbeitsbereich: Workspace.sbb_eigentumsflaeche,
      fkLayer: LayerCode.f_teilparzelle,
      properties: {
        featureCode: LayerCode.f_teilparzelle,
        outFields: ['GEMEINDE', 'OBJEKTNR', 'ANLAGE_NR'],
        searchFields: ['GEMEINDE', 'OBJEKTNR', 'ANLAGE_NR'],
        orderByFields: ['GEMEINDE', 'OBJEKTNR', 'ANLAGE_NR'],
        suggestionTemplate: '{GEMEINDE} | {OBJEKTNR} | {ANLAGE_NR}',
        name: 'JSON_CONFIG.SEARCH.INVENTARNR_NAME',
        placeholder: 'JSON_CONFIG.SEARCH.INVENTARNR_PLACEHOLDER',
        ...defaultProperties,
      },
    },
    {
      type: SERVICE_TYPES.featureLayer,
      fkLayer: LayerCode.f_public_sap_mietertraege,
      properties: {
        searchFields: ['WE_NR'],
        displayField: 'WE_NR',
        outFields: ['WE_NR'],
        orderByFields: ['WE_NR'],
        name: 'JSON_CONFIG.SEARCH.WENR_NAME',
        placeholder: 'JSON_CONFIG.SEARCH.WENR_PLACEHOLDER',
        ...defaultProperties,
        zoomScale: 1500,
      },
    },
    {
      comment: 'Verkaufsobjekt search using ID_SAP - eg. 207329',
      type: SERVICE_TYPES.custom_search_Layer,
      fkLayer: LayerCode.f_public_verkaufsobjekte,
      properties: {
        featureCode: LayerCode.f_public_verkaufsobjekte,
        searchFields: ['ID_SAP'],
        displayField: 'ID_SAP',
        outFields: ['ID_SAP'],
        orderByFields: ['ID_SAP'],
        name: 'JSON_CONFIG.SEARCH.IDSAP_NAME',
        placeholder: 'JSON_CONFIG.SEARCH.IDSAP_PLACEHOLDER',
        ...defaultProperties,
      },
    },
    {
      comment: 'Verkaufsobjekt search EGRID',
      type: SERVICE_TYPES.featureLayer,
      fkLayer: LayerCode.f_public_verkaufsobjekte,
      properties: {
        searchFields: ['EGRIS_EGRID'],
        displayField: 'EGRIS_EGRID',
        outFields: ['EGRIS_EGRID'],
        orderByFields: ['EGRIS_EGRID'],
        name: 'JSON_CONFIG.SEARCH.Transaktionsflaeche',
        placeholder: 'JSON_CONFIG.SEARCH.Transaktionsflaeche',
        ...defaultProperties,
      },
    },
    {
      comment: 'REFX_GB search using IM_SCHLUESSEL - eg. 4400/30142/101',
      type: SERVICE_TYPES.featureLayer,
      fkLayer: LayerCode.f_public_refx_gb,
      properties: {
        searchFields: ['IM_SCHLUESSEL'],
        displayField: 'IM_SCHLUESSEL',
        outFields: ['IM_SCHLUESSEL'],
        orderByFields: ['IM_SCHLUESSEL'],
        name: 'JSON_CONFIG.SEARCH.REFX_GB_NAME',
        placeholder: 'JSON_CONFIG.SEARCH.REFX_GB_PLACEHOLDER',
        ...defaultProperties,
        zoomScale: 1500,
      },
    },
    {
      comment: 'REFX_GR search using IM_SCHLUESSEL - eg. 4400/30142/701',
      type: SERVICE_TYPES.featureLayer,
      fkLayer: LayerCode.f_public_refx_gr,
      properties: {
        searchFields: ['IM_SCHLUESSEL'],
        displayField: 'IM_SCHLUESSEL',
        outFields: ['IM_SCHLUESSEL'],
        orderByFields: ['IM_SCHLUESSEL'],
        name: 'JSON_CONFIG.SEARCH.REFX_GR_NAME',
        placeholder: 'JSON_CONFIG.SEARCH.REFX_GR_PLACEHOLDER',
        ...defaultProperties,
      },
    },
    {
      comment: 'Strategieflaeche search using ID - eg. 35797',
      type: SERVICE_TYPES.custom_search_Layer,
      fkLayer: LayerCode.f_public_strategieflaeche,
      properties: {
        featureCode: LayerCode.f_public_strategieflaeche,
        searchFields: ['ID'],
        displayField: 'ID',
        outFields: ['ID'],
        orderByFields: ['ID'],
        name: 'JSON_CONFIG.SEARCH.ID_NAME',
        placeholder: 'JSON_CONFIG.SEARCH.ID_PLACEHOLDER',
        ...defaultProperties,
        zoomScale: 3000,
      },
    },
    {
      comment: 'Energie Trasse search using NUMMER eg. 101',
      type: SERVICE_TYPES.custom_search_Layer,
      fkLayer: LayerCode.f_public_trasse,
      properties: {
        featureCode: LayerCode.f_public_trasse,
        searchFields: ['NUMMER'],
        orderByFields: ['NUMMER'],
        displayField: 'NUMMER',
        outFields: ['NUMMER'],
        name: 'JSON_CONFIG.SEARCH.TRASSE_NUMMER',
        placeholder: 'JSON_CONFIG.SEARCH.TRASSE_PLACEHOLDER',
        ...defaultProperties,
      },
    },
    {
      comment: 'Altlasten Standort search using OBJEKTNUMMER eg. B.6083',
      type: SERVICE_TYPES.featureLayer,
      fkLayer: LayerCode.f_public_altlasten_standort,
      properties: {
        searchFields: ['OBJEKTNUMMER'],
        displayField: 'OBJEKTNUMMER',
        outFields: ['OBJEKTNUMMER'],
        orderByFields: ['OBJEKTNUMMER'],
        name: 'JSON_CONFIG.SEARCH.AL_STANDORT_NAME',
        placeholder: 'JSON_CONFIG.SEARCH.AL_STANDORT_PLACEHOLDER',
        ...defaultProperties,
      },
    },
    {
      comment: 'EGRID search',
      type: SERVICE_TYPES.featureLayer,
      fkLayer: LayerCode.f_liegenschaft_grundstuecke,
      properties: {
        searchFields: ['gemeinde', 'egris_egrid', 'nummer'],
        outFields: ['gemeinde', 'egris_egrid', 'nummer'],
        orderByFields: ['gemeinde', 'egris_egrid', 'nummer'],
        suggestionTemplate: '{GEMEINDE} | {EGRIS_EGRID} | {NUMMER}',
        name: 'JSON_CONFIG.SEARCH.LIEGENSCHAFTEN_GRUNDSTUECKE',
        placeholder: 'JSON_CONFIG.SEARCH.LIEGENSCHAFTEN_GRUNDSTUECKE',
        ...defaultProperties,
      },
    },
    {
      comment: 'EGRID search',
      type: SERVICE_TYPES.featureLayer,
      fkLayer: LayerCode.f_liegenschaften_selbststaendige_rechte,
      properties: {
        searchFields: ['gemeinde', 'egris_egrid', 'nummer'],
        outFields: ['gemeinde', 'egris_egrid', 'nummer'],
        orderByFields: ['gemeinde', 'egris_egrid', 'nummer'],
        suggestionTemplate: '{GEMEINDE} | {EGRIS_EGRID} | {NUMMER}',
        name: 'JSON_CONFIG.SEARCH.LIEGENSCHAFTEN_SELBSTAENDIGE_RECHTE',
        placeholder: 'JSON_CONFIG.SEARCH.LIEGENSCHAFTEN_SELBSTAENDIGE_RECHTE',
        ...defaultProperties,
      },
    },
  ],
  hierarchicalSearch: [
    {
      id: 'search_parzelle_sbb',
      widget_title: 'HEADER_PANEL.SEARCH_PARZELLEN_SBB',
      sbb_grundstueck_label: 'JSON_CONFIG.SEARCH.PARZELLEN_NAME',
      fkLayer: LayerCode.map_parzelle,
      keyField: 'GLOBALID',
      headSearchField: 'GEMEINDE',
      searchField: 'PARZNR',
    },
    {
      id: 'search_parzelle_ch',
      widget_title: 'HEADER_PANEL.SEARCH_PARZELLEN_CH',
      sbb_grundstueck_label: 'JSON_CONFIG.SEARCH.PARZELLEN_NAME_CH',
      fkLayer: LayerCode.av_webgis_sw_liegenschaftenNr,
      keyField: 'objectid',
      headSearchField: 'gemeinde',
      searchField: 'nummer',
    },
    {
      id: 'hektometer_search',
      fkLayer: LayerCode.map_Hektometer,
      keyField: 'ID',
      headSearch: {
        fkLayer: LayerCode.map_Kilometrierung,
        fields: ['LINIENNUMMER', 'LINIENBEZEICHNUNG'],
      },
      baseSearch: {
        fkLayer: LayerCode.map_Hektometer,
        fields: ['KM', 'KILOMETRIERUNGSLINIE_NUMMER'],
      },
    },
  ],
};
